//基本路由 
export default {
     'about': resolve => require(['../page/About.vue'], resolve),
     'download': resolve => require(['../page/Download.vue'], resolve),
     'index': resolve => require(['../page/Index.vue'], resolve),
    //  'login': resolve => require(['../page/Login.vue'], resolve),
    //  'register': resolve => require(['../page/Register.vue'], resolve),
     'shopkeeper': resolve => require(['../page/Shopkeeper.vue'], resolve),

       //首页
      '/': resolve => require(['../page/Index.vue'], resolve)
}


// WEBPACK FOOTER //
// ./src/routes/base.js